export default __webpack_public_path__ + "static/media/5f3128e2e912d10253d78f606797bad81575575492270.eb287e2f.webp";